import $ from 'jquery';

function FixNavigation(element) {
  this.element = element;
  this.process();
  this.ready();
}

FixNavigation.prototype = {
  process() {
    $('.menuparent, .expanded, .collapsed', this.element).each((i, item) => {
      // handles the parent term (if hidden)
      const $parent = $(item).children('a');
      if (!$parent.length || $parent.is('.hidden')) {
        $(item).remove();
      }

      // handles the term to see if it only parents orphans.
      let $children = $('> ul > li', item);
      if (!$parent.is('.hidden') && $children.length) {
        // Logged in: shows links with a hidden class.
        $children.children('a.hidden').parent().remove();
        // Logged out: shows an empty li :\
        $children.filter(':empty').remove();
        // Reset $children to reflect potential missing items.
        $children = $('> ul > li', item);
        // If the list is empty, the parent should no longer be
        // labeled as such and the list should be removed.
        if (!$children.length) {
          $(item).removeClass('menuparent expanded collapsed'); // unlabel
          $(item).find('ul').remove();
        }
      }
    });
  },
  ready() {
    $(this.element).addClass('ready');
  },
};

export default FixNavigation;



// WEBPACK FOOTER //
// ./FixNavigation.js